import React from 'react';
import Glide from '@glidejs/glide';
import { PauseIcon } from '../../react/eagerlyIcons/src/__generated__/icons';
import { PlayIcon } from '../../react/eagerlyIcons/src/__generated__/icons';

export default class Autoplay {
	constructor(element) {
		this.element = element;
		this.interval = element.dataset.interval;
		this.options = {
			autoplay: this.interval, // Autoplay interval from data attribute
			perView: 1,
			hoverpause: false,
			swipeThreshold: false,
			dragThreshold: false,
			animationDuration: 0,
			rewindDuration: 0,
			gap: 0,
		};

		// Initialize Glide instance
		this.glide = new Glide(this.element, this.options).mount();

		// Set up play/pause button
		this.initPlayPauseButton();
	}

	initPlayPauseButton() {
		const playPauseButton = document.getElementById('playPauseButton');
		let isPaused = false;

		playPauseButton.addEventListener('click', () => {
			if (isPaused) {
				this.glide.play();
				playPauseButton.setAttribute('aria-label', 'Video pauzeren');

				playPauseButton.innerHTML = `
          <svg class="icon pause-icon" width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect x="6" y="5" width="4" height="14" fill="currentColor"/>
            <rect x="14" y="5" width="4" height="14" fill="currentColor"/>
          </svg>
        `;
			} else {
				this.glide.pause();
				playPauseButton.setAttribute('aria-label', 'Video afspelen');
				playPauseButton.innerHTML = `
          <svg class="icon play-icon" width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M8 5v14l11-7z" fill="currentColor"/>
          </svg>
        `;
			}
			isPaused = !isPaused;
		});
	}
}
